<template>
  <div class="proj-rule-edit-digital-item" :class="{ 'checked-rule-digital-item' : ruleDigitalItem.ruleResult }">
    <el-checkbox class="eb-checkbox" v-model="ruleDigitalItem.ruleResult" @change="handleRuleResultCheckboxChange()"></el-checkbox>
    &nbsp;
    <div class="rule-name">
      <el-tooltip :disabled="ruleDigitalItem.ruleName.length <= 10" :content="ruleDigitalItem.ruleName" placement="top">
        <span>{{ ruleTypeItemIndex+1 }}.{{ruleDigitalItemIndex+1}} {{ ruleDigitalItem.ruleName }}</span>
      </el-tooltip>
    </div>
    <div class="rule-edit-area">
      <template v-for="(contentItem, $index) in ruleDigitalItem.ruleContent">
        <template v-if="contentItem.type == 'images'">
          <el-input class="eb-input input-item" :key="ruleDigitalItem.ruleId + '_' + $index" v-model="contentItem.content" @focus="handleInputFocus(contentItem)"
            @blur="handleInputBlur(contentItem)" size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'text'">
          <el-input class="eb-input input-item" :key="ruleDigitalItem.ruleId + '_' + $index" v-model="contentItem.content" @focus="handleInputFocus(contentItem)"
            @blur="handleInputBlur(contentItem)" size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'radio'">
          <el-radio class="eb-radio" :name="'contentItem_' + ruleDigitalItem.ruleId" :key="ruleDigitalItem.ruleId + '_' + $index" v-model="ruleDigitalItem.checkedContentItem"
            :label="ruleDigitalItem.ruleId + '_' + $index" @change="handleRadioChange(contentItem, $index)">{{contentItem.content}}</el-radio>
        </template>

        <template v-if="contentItem.type == 'radioText'">
          <el-radio class="eb-radio" :name="'contentItem_' + ruleDigitalItem.ruleId" :key="ruleDigitalItem.ruleId + '_' + $index" v-model="ruleDigitalItem.checkedContentItem"
            :label="ruleDigitalItem.ruleId + '_' + $index" @change="handleRadioChange(contentItem, $index)">
            <el-input class="eb-input" v-model="contentItem.content" @focus="handleRadioTextInputFocus(contentItem, $index)" @blur="handleInputBlur(contentItem)"
              @keydown="handleRadioTextInputKeyDown()" size="small"></el-input>
          </el-radio>
        </template>

        <template v-if="contentItem.type == 'buyerfile'">
          <el-input class="eb-input input-item short-input" :key="ruleDigitalItem.ruleId + '_' + $index + '_1'" v-model="contentItem.content"
            @focus="handleInputFocus(contentItem)" @blur="handleInputBlur(contentItem)" size="small"></el-input>
          <el-upload :class="{'eb-file-uploaded' : contentItem.fileList.length > 0 }" name="myFile" :action="uploadUrl" :on-error="handleUploadBuyerFileError"
            :before-upload="handleBuyerFileBeforeUpload" :on-success="handleUploadBuyerFileSuccess" :before-remove="handleBuyerFileBeforeRemove"
            :limit="1" :multiple="false" :file-list="contentItem.fileList" :on-preview="handleBuyerFilePreview" :key="ruleDigitalItem.ruleId + '_' + $index + '_2'">
            <!-- :on-exceed="handleUploadBuyerFileExceed" -->
            <el-button class="eb-button-red eb-button-small" v-if="contentItem.fileList.length === 0">点击上传</el-button>
            <div slot="tip" class="el-upload__tip" v-if="contentItem.fileList.length === 0">
              请上传小于10MB的文件
            </div>
          </el-upload>
        </template>

        <template v-if="contentItem.type == 'supplierfile'">
          <el-input class="eb-input input-item short-input" :key="ruleDigitalItem.ruleId + '_' + $index" v-model="contentItem.content"
            @focus="handleInputFocus(contentItem)" @blur="handleInputBlur(contentItem)" size="small"></el-input>
        </template>

        <template v-if="contentItem.type == 'text-detail'">
          <el-input class="eb-input input-item text-detail-input-item" :key="ruleDigitalItem.ruleId + '_' + $index" v-model="contentItem.content"
            @focus="handleInputFocus(contentItem)" @blur="handleInputBlur(contentItem)" size="small"></el-input>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from '@/plugins/event-bus';
import { baseURL } from '@/plugins/axios.js';
import { validateFileSize } from '@/plugins/upload-file';
import { downloadFile } from '@/plugins/download-file';
import { cloneDeep } from 'lodash';
import { RULE_CONTENT_TYPE } from '@/services/rule/rule-digital-service';

export default {
  props: {
    ruleTypeItemIndex: {
      type: Number,
      required: true
    },
    ruleDigitalItem: {
      type: Object,
      required: true
    },
    ruleDigitalItemIndex: {
      type: Number,
      required: true
    },
    uploadUrl: {
      type: String,
      required: true
    }
  },
  // data() {},
  computed: {
    ruleContentType() {
      return this.ruleDigitalItem.ruleContent[0]['type'];
    }
  },
  components: {},
  created() {
    this.ruleDigitalItem.ruleContent.forEach((item, idx) => {
      if (item.isCheck) {
        // 初始化单选选中项, 仅针对单选框
        this.ruleDigitalItem.checkedContentItem = this.ruleDigitalItem.ruleId + '_' + idx;
      }

      // 自定义选项单选框
      if (item.type === 'radioText' && item.content === '') {
        item.content = '请输入自定义要求';
      }

      // 初始化文件列表，采购方上传的文件
      if (item.type === 'buyerfile') {
        item.fileList = this.trunsToUploadFilelist(item.url);
      }
    });
  },
  watch: {
    uploadUrl: function(newVal) {
    }
  },
  methods: {
    // 转换为文件列表
    trunsToUploadFilelist(fileUrl) {
      if (fileUrl && fileUrl.length > 0) {
        return [{ name: this.$options.filters['projFileName'](fileUrl), url: fileUrl }];
      } else {
        return [];
      }
    },
    // 规则勾选事件
    handleRuleResultCheckboxChange() {
      if (this.ruleDigitalItem.ruleResult) {
        // 规则选中
        if (this.ruleContentType === RULE_CONTENT_TYPE.RADIO || this.ruleContentType === RULE_CONTENT_TYPE.RADIO_TEXT) {
          // 是单项选择选中
          let ruleContent = this.ruleDigitalItem.ruleContent;
          let lastRuleContentItem = cloneDeep(ruleContent[ruleContent.length - 1]);
          lastRuleContentItem.isCheck = true;
          this.ruleDigitalItem.ruleContent.splice(ruleContent.length - 1, 1, lastRuleContentItem);
          this.ruleDigitalItem.checkedContentItem = this.ruleDigitalItem.ruleId + '_' + (ruleContent.length - 1);
          this.ruleDigitalItem.ruleRemark = lastRuleContentItem.content;
        } else {
          // 非单项选择选中
          this.ruleDigitalItem.ruleRemark = this.ruleDigitalItem.ruleContent[0].content;
        }
      } else {
        // 规则取消勾选
        this.ruleDigitalItem.ruleRemark = '';
        // 取消规则的子项选中
        this.ruleDigitalItem.ruleContent.forEach((item, idx) => {
          if (item.isCheck) {
            item.isCheck = false;
            this.ruleDigitalItem.ruleContent.splice(idx, 1, item);
            this.ruleDigitalItem.checkedContentItem = null;
          }
        });
      }

      this.editProjRule().catch(err => {
        if (err) {
          this.$message.error('更新项目模板规则失败');
        }
      });
    },
    // 输入框聚焦事件
    handleInputFocus(contentItem) {
      if (this.ruleDigitalItem.ruleResult === false) {
        this.ruleDigitalItem.ruleResult = true;
      }
    },
    // 输入框失去焦点事件
    handleInputBlur(contentItem) {
      contentItem.isCheck = true;
      this.ruleDigitalItem.ruleResult = true;
      this.ruleDigitalItem.ruleRemark = contentItem.content; // this.ruleDigitalItem.ruleContent[0].content;
      this.editProjRule().catch(err => {
        if (err) {
          this.$message.error('更新项目模板规则失败');
        }
      });
    },
    // 单选框值改变事件
    handleRadioChange(contentItem, index) {
      this.ruleDigitalItem.ruleResult = true;
      this.ruleDigitalItem.ruleRemark = contentItem.content;
      this.ruleDigitalItem.ruleContent.forEach((item, idx) => {
        if (index === idx) {
          item.isCheck = true;
        } else {
          item.isCheck = false;
        }
        // 刷新数组，重新渲染，上面代码不会让ui重新渲染
        this.ruleDigitalItem.ruleContent.splice(idx, 1, item);
      });

      this.editProjRule().catch(err => {
        if (err) {
          this.$message.error('更新项目模板规则失败');
        }
      });
    },
    // 单选框 文本输入 聚焦事件
    handleRadioTextInputFocus(contentItem, index) {
      this.ruleDigitalItem.checkedContentItem = this.ruleDigitalItem.ruleId + '_' + index;
      this.handleRadioChange(contentItem, index);
    },
    handleRadioTextInputKeyDown() {
    },
    // 文件上传之前回调
    handleBuyerFileBeforeUpload(file) {
      if (!validateFileSize(file)) {
        this.$message.error('请上传小于10M的附件');
        return false;
      }
      return true;
    },
    // 文件删除之前回调
    handleBuyerFileBeforeRemove(file, fileList) {
      let params = {
        ruleId: this.ruleDigitalItem.ruleId,
        ruleContent: this.ruleDigitalItem.ruleContent
      };
      params.ruleContent[0].url = '';
      // 删除不相干参数
      delete params.ruleContent[0].fileList;

      return new Promise((resolve, reject) => {
        this.editProjRuleByParams(params)
          .then(res => {
            let ruleContent = cloneDeep(this.ruleDigitalItem.ruleContent);
            ruleContent[0].url = '';
            ruleContent[0].fileList = [];
            this.ruleDigitalItem.ruleContent.splice(0, 1, ruleContent[0]);
            resolve(true);
          })
          .catch(err => {
            if (err) {
              this.$message.error('删除文件失败');
            }
            // 返回错误，不进行删除操作
            reject(err);
          });
      });
    },
    // 上传失败回调
    handleUploadBuyerFileError(err, file, fileList) {
      if (err) {
        this.$message.error('文件上传失败');
      }
    },
    // 上传成功回调
    handleUploadBuyerFileSuccess(response, file, fileList) {
      let params = {
        ruleId: this.ruleDigitalItem.ruleId,
        ruleContent: this.ruleDigitalItem.ruleContent,
        ruleRemark: this.ruleDigitalItem.ruleContent[0].content,
        ruleResult: true
      };
      params.ruleContent[0].url = response;

      // 保存数据库
      this.editProjRuleByParams(params)
        .then(res => {
          let ruleContent = cloneDeep(this.ruleDigitalItem.ruleContent);
          ruleContent[0].url = response;
          ruleContent[0].fileList = this.trunsToUploadFilelist(response);
          this.ruleDigitalItem.ruleContent.splice(0, 1, ruleContent[0]);
          this.ruleDigitalItem.ruleRemark = params.ruleRemark;
          this.ruleDigitalItem.ruleResult = true;
        })
        .catch(err => {
          if (err) {
            this.$message.error('保存上传文件到数据库失败');
          }
        });
    },
    // 文件下载
    handleBuyerFilePreview(file) {
      downloadFile(baseURL + file.url, this.$options.filters['projFileName'](file.url));
    },
    // 修改项目
    editProjRule() {
      return this.editProjRuleByParams({
        ruleId: this.ruleDigitalItem.ruleId,
        ruleContent: this.ruleDigitalItem.ruleContent,
        ruleRemark: this.ruleDigitalItem.ruleRemark,
        ruleResult: this.ruleDigitalItem.ruleResult
      });
    },
    editProjRuleByParams(params) {
      return new Promise((resolve, reject) => {
        EventBus.$emit(
          'projEditRule',
          {
            ruleId: params.ruleId,
            ruleContent: params.ruleContent,
            ruleRemark: params.ruleRemark,
            ruleResult: params.ruleResult
          },
          {
            success(res) {
              resolve(res);
            },
            error(err) {
              reject(err);
            }
          }
        );
      });
    }
  }
};
</script>

<style lang="less">
.proj-rule-edit-digital-item {
  line-height: 38px;
  display: flex; /*Flex布局*/
  display: -webkit-flex; /* Safari */
  align-items: baseline; /*指定基线居中*/
  /** 规则名称 **/
  .rule-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 205px;
    min-width: 205px;
    display: inline-block;
  }
  /** 输入框 **/
  .input-item {
    height: 30px;
    width: 480px;
    .el-input__inner {
      border-radius: 0px;
    }
  }
  .short-input {
    width: 200px;
  }
  /** 单选框 **/
  .eb-radio {
    margin-left: 0px;
    margin-right: 10px;
    .el-radio__label {
      padding-left: 5px;
    }
    .el-input__inner {
      width: 200px;
      border-radius: 0px;
    }
  }
  /** 信息显示 **/
  .text-detail-input-item {
    .el-input__inner {
      background: #efefef;
      border-color: #efefef;
      &:hover {
        background: #ffffff;
        border-color: #cecece;
      }
    }
  }
  /** 上传 **/
  .eb-file-uploaded {
    .el-upload {
      display: none;
    }
  }
}
/** 选中的规则附加样式 **/
.checked-rule-digital-item {
  .input-item {
    .el-input__inner {
      border-color: #fb5b3b;
      color: #fb5b3b;
    }
  }
  .text-detail-input-item {
    .el-input__inner {
      border-color: #efefef;
      &:hover {
        border-color: #fb5b3b;
      }
    }
  }
  .eb-radio.is-checked {
    .eb-input {
      input {
        border-color: #fb5b3b;
        color: #fb5b3b;
      }
    }
  }
}
</style>
